<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card max-width="100%" class="pa-0 mt-2 elevation-0" v-else>
      <v-card-text flat>
        <v-data-table
          :search="search"
          class="elevation-1"
          dense
          :headers="headers"
          :items="viewCorpItems"
          item-key="name"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="viewCorparatePagination()"
          :no-data-text="Nodata"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ viewCorpItems.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.corp_name`]="{ item }">
            <span class="caption"
              ><b>{{ item.corp_name }}</b></span
            >
            <br />
            <span class="caption">{{ item.corp_display_id }}</span>
          </template>

          <template v-slot:[`item.status_text`]="{ item }">
            <span class="caption orange--text" v-if="item.status == 3"
              >PENDING</span
            >
            <span class="caption red--text" v-if="item.status == 2"
              >REJECTED</span
            >
            <span class="caption green--text" v-if="item.status == 1"
              >ACTIVE</span
            >
          </template>
          <template v-slot:[`item.onboarded_on`]="{ item }">
            <span class="caption">{{ item.onboarded_on }}</span>
          </template>
          <template v-slot:[`item.doc_status`]="{ item }">
            <span class="caption">{{ item.doc_status }}</span>
          </template>
          <template v-slot:[`item.employee_count`]="{ item }">
            <span class="caption">{{ item.employee_count }}</span>
          </template>

          <template v-slot:[`item.funding_amount`]="{ item }">
            <span class="caption">{{ item.funding_amount }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="getCorpById(item)"
                  small
                  class="mr-2"
                  v-on="on"
                  color="primary"
                  >mdi-eye</v-icon
                >
              </template>
              <span>View details</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-card elevation="4" class="mb-6">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>Filters</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-layout row wrap>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        lg="3"
                        xl="3"
                        xs="12"
                        class="mt-n1"
                      >
                        <label class="caption">Status</label>
                        <!-- <label class="caption primary--text"><b>STATUS</b></label> -->
                        <v-select
                          v-model="userStatusFilter"
                          dense
                          :items="statusItems"
                          item-text="statusName"
                          item-value="StatusId"
                          class="mt-1"
                          solo
                          elevation-5
                        ></v-select>
                      </v-col>
                      <!-- <v-col lg="2">
                <label class="caption primary--text"
                  ><b>DOCUMENT STATUS</b></label
                >
                <v-select
                  v-model="docStatus"
                  dense
                  :items="docStatusList"
                  label="Doc Status"
                  class="mt-7"
                  outlined
                ></v-select>
              </v-col> -->
                      <v-col
                        cols="12"
                        sm="6"
                        md="1"
                        lg="1"
                        xl="1"
                        xs="12"
                        class="mt-4"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              fab
                              color="primary"
                              @click="viewCorparate()"
                              class="elevation-0 mt-2"
                              v-on="on"
                            >
                              <v-icon dark>mdi-filter</v-icon>
                            </v-btn>
                          </template>
                          <span>Filter</span>
                        </v-tooltip>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        lg="3"
                        xl="3"
                        xs="12"
                        class="mt-0 mr-2"
                      >
                        <label class="caption">Search </label>
                        <v-text-field
                          dense
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          auto-grow
                          solo
                          elevation-5
                        ></v-text-field>
                      </v-col>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </template>
        </v-data-table>
        <v-dialog v-model="empStatus" transition="dialog-top-transition">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >BENEFICIARIES</v-card-title
            >
            <v-card-text>
              <div class="mt-2">
                <v-data-table
                  dense
                  :headers="headersEmp"
                  :items="empItem"
                  item-key="name"
                  class="elevation-0"
                ></v-data-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="empStatus = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <div>
      <ViewDetailsCorparate
        :viewCorporateDetailsArray="viewCorporateDetailsArray"
        :registered_address="registered_address"
        :business_address="business_address"
        :first_cardinfo="first_cardinfo"
        :contactpersondetails="contactpersondetails"
        :PackDetails="PackDetails"
        :RefDetails="RefDetails"
        :bankitems="bankitems"
        :fileList="fileList"
        :viewDetailStatus="viewDetailStatus"
        @clicked="viewDetailStatus = false"
      />
      <!-- <OverleyProccessg :overlay="overlay" /> -->
    </div>
  </div>
</template>
<script>
// import OverleyProccessg from "@/views/OverleyProccessg.vue";
// import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";

import ViewDetailsCorparate from "@/components/Referrer/ViewDetailsCorparate.vue";
export default {
  components: {
    ViewDetailsCorparate,
    // OverleyProccessg,
  },

  data: () => ({
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    viewDetailStatus: false,
    docStatusList: [],
    docStatus: "",
    search: "",
    panel: 0,
    overlay: false,
    empItem: [
      {
        sl_no: "1",
        first_name: "Subha Nayak",
        realtionship: "Brother",
        country: "India",
      },
      {
        sl_no: "2",
        first_name: "Jisha Shinu",
        realtionship: "Sister",
        country: "India",
      },
    ],
    headersEmp: [
      {
        text: "Sl No",
        align: "start",
        sortable: false,
        value: "sl_no",
        width: "50px",
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "first_name",
        width: "50px",
      },
      {
        text: "Relation",
        value: "realtionship",
        align: "start",
        sortable: false,
        width: "50px",
      },
      {
        text: "Country",
        value: "country",
        align: "start",
        sortable: false,
        width: "50px",
      },
      {
        text: "Delivery Type",
        value: "delivery_type",
        align: "start",
        sortable: false,
        width: "50px",
      },
      {
        text: "Correspondent",
        value: "correpondent_details",
        align: "start",
        sortable: false,
        width: "50px",
      },
      {
        text: "Bank Details",
        value: "bank_details",
        align: "start",
        sortable: false,
        width: "50px",
      },
      {
        text: "Wallet Details",
        value: "wallet_details",
        align: "start",
        sortable: false,
        width: "50px",
      },
    ],
    transHeader: [
      {
        text: "Sl No",
        align: "start",
        sortable: false,
        value: "sl_no",
      },
      {
        text: "Transaction Name",
        align: "start",
        sortable: false,
        value: "txn_name",
      },
      {
        text: "Transaction To",
        value: "txn_to",
        align: "start",
        sortable: false,
      },
      {
        text: "Transaction ID",
        value: "txn_id",
        align: "start",
        sortable: false,
      },
      {
        text: "Amount",
        value: "txn_amount",
        align: "start",
        sortable: false,
      },
      {
        text: "Date",
        value: "txn_date",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        value: "txn_status",
        align: "start",
        sortable: false,
      },
    ],
    empStatus: false,
    corpList: ["Mobil80 Solutions and Services", "Dwise Solutions"],
    deviceTypeList: ["All", "Android", "iOS"],
    userStatusFilter: "0",
    statusItems: [
      {
        statusName: "All",
        StatusId: "0",
      },
      {
        statusName: "Active",
        StatusId: "1",
      },
      {
        statusName: "Pending",
        StatusId: "3",
      },
      {
        statusName: "Rejected",
        StatusId: "2",
      },
    ],

    headers: [
      {
        text: "SL NO",
        align: "start",
        sortable: false,
        value: "sl_no",
        width: "100px",
      },

      {
        text: "CORPORATE",
        // align: "start",
        sortable: false,
        value: "corp_name",
        width: "150px",
      },

      {
        text: "ONBOARDED ON",
        value: "onboarded_on",
        align: "start",
        width: "150px",
        sortable: false,
      },
      // {
      //   text: "DOC",
      //   value: "doc_status",
      //   align: "start",
      //   sortable: false,
      // },
      // {
      //   text: "#EMP",
      //   value: "employee_count",
      //   align: "start",
      //   sortable: false,
      //   width: "100px",
      // },
      // {
      //   text: "BALANCE (MYR)",
      //   value: "funding_amount",
      //   align: "start",
      //   sortable: false,
      //   width: "140px",
      // },
      {
        text: "STATUS",
        value: "status_text",
        align: "start",
        sortable: false,
        width: "100px",
      },
      {
        text: "ACTION",
        value: "actions",
        align: "start",
        width: "100px",
        sortable: false,
      },
    ],
    viewCorpItems: [],
    viewCorporateDetailsArray: {},
    checkaccessdata: {},
    registered_address: {},
    business_address: {},
    first_cardinfo: {},
    contactpersondetails: [],
    PackDetails: [],
    RefDetails: {},
    bankitems: [],
    fileList: [],
    Nodata: "",
  }),

  mounted() {
    this.viewCorparate();
  },
  methods: {
    convertTimeStampToDate(date) {
      let day = date.split(" ")[0].split("-")[2];
      let month = date.split(" ")[0].split("-")[1];
      let year = date.split(" ")[0].split("-")[0];
      let hrs = date.split(" ")[1].split(":")[0];
      let mins = date.split(" ")[1].split(":")[1];
      let new_date = Math.floor(
        new Date(year, month - 1, day, hrs, mins, 0).getTime()
      );

      let a = new Date(new_date).toLocaleDateString("en-in", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      return a;
    },

    async viewCorparatePagination() {
      if (this.viewCorpItems.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;
        var inputData = {
          method_name: "REFSERVICE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "VIEWCORP",
            status: this.userStatusFilter,
            logged_user_id: this.$store.getters.get_getRefDetails.user_id,
          },
        };

        var responseData = await apiCall(inputData);

        this.viewCorpItems = this.viewCorpItems.concat(responseData.data.data);
      }
    },
    async viewCorparate() {
      this.overlay = true;
      var inputData = {
        method_name: "REFSERVICE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "VIEWCORP",
          status: this.userStatusFilter,
          logged_user_id: this.$store.getters.get_getRefDetails.user_id,
        },
      };
      this.overlay = false;
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null) {
          this.viewCorpItems = responseData.data.data;
        }
        this.totalCount = responseData.data.data[0].total_count;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.viewCorpItems = [];
      }
    },

    async getCorpById(item) {
      this.overlay = true;
      var inputData = {
        method_name: "REFSERVICE",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPBYID",
          corp_id: item.corp_id,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.viewDetailStatus = true;

        this.viewCorporateDetailsArray = responseData.data.data;

        this.registered_address =
          this.viewCorporateDetailsArray.registered_address;
        this.business_address = this.viewCorporateDetailsArray.business_address;
        this.first_cardinfo = this.viewCorporateDetailsArray.first_cardinfo;

        this.contactpersondetails =
          this.viewCorporateDetailsArray.contact_person;
        if (this.viewCorporateDetailsArray.pack_details != null) {
          this.PackDetails = this.viewCorporateDetailsArray.pack_details;
        }
        this.contactpersondetails =
          this.viewCorporateDetailsArray.contact_person;
        if (this.viewCorporateDetailsArray.referrer_details != null) {
          this.RefDetails = this.viewCorporateDetailsArray.referrer_details;
        }

        this.bankitems = this.viewCorporateDetailsArray.bank_details;
        this.fileList =
          this.viewCorporateDetailsArray.documents == null ||
          this.viewCorporateDetailsArray.documents == undefined
            ? []
            : this.viewCorporateDetailsArray.documents;
        var self = this;
        this.fileList.forEach(function (ele) {
          (ele.fileName = self.getFileName(ele.doc_url)),
            (ele.docExtn = self.getExtension(ele.fileName));
        });
      }

      this.overlay = false;
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    getFileName(filename) {
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
    getEmployeeList(item) {
      if (item.empl) this.empStatus = true;
    },
    // async checkaccess() {
    //   var inputData = {
    //     method_name: "ADMINUSERS",
    //     page_no: null,
    //     record_count: 0,
    //     page_size: null,
    //     app_code: "APORTAL",
    //     method_param: {
    //       action: "CHECKACESS",
    //       user_id: this.$store.getters.get_UserDetails.user_id,
    //       module_code: "CORPS",
    //       module_type: "1",
    //     },
    //   };
    //   var responseData = await apiCall(inputData);

    //   this.checkaccessdata = responseData.data.data[0];

    //   if (this.checkaccessdata.is_viewer == true) {
    //     this.viewCorparate(this.userStatusFilter);
    //   }
    // },
  },
};
</script>
